import React, { useState } from "react";
import Card from "app/popleads/components/ui-kit/Card";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import { POPUP_CONTENTS } from "../utils/constants";
import { useExtensionContext } from "../ExtensionContext";
import { StyledCardContent } from "./common/styled";
import ExtensionCampaignSearchInput from "./ExtensionCampaignSearchInput";
import { toast } from "react-toastify";
import useEtiketEkle from "app/popleads/hooks/useEtiketEkle";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { colors } from "app/popleads/components/ui-kit/colors";
import FeatherIcon from "feather-icons-react";

export const StyledCampaignLinkContent = styled(StyledCardContent)`
    color: ${(props) => colors.l3rnTech[900]};
    &:hover {
        text-decoration: underline;
    }
`;

const CarouselNavButton = styled.button`
    background: transparent;
    border: none;
    border-radius: 4px;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: ${colors.l3rnTech[900]};
    transition: all 0.2s ease;
    flex-shrink: 0;
    padding: 0;

    &:hover:not(:disabled) {
        background: ${colors.neutral[100]};
        color: ${colors.neutral[700]};
    }

    &:disabled {
        opacity: 0.3;
        cursor: not-allowed;
    }
`;

const HeaderButtonsWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;
const ExtensionCourseCard = () => {
    const {
        profile,
        setState,
        popit,
        collapsedCards,
        setCollapsedCard,
        etiketListLoading,
        courseRef,
    } = useExtensionContext();
    const [showSearchCampaign, setShowSearchCampaign] = useState(false);
    const [currentCampaignIndex, setCurrentCampaignIndex] = useState(0);
    const collapsed = collapsedCards.course;
    const handleCollapseChange = (val) => {
        setCollapsedCard("course", val);
    };

    const { etiketEkle } = useEtiketEkle();
    const user = useSelector((state) => state.auth.user);

    const etiketList = profile?.etiket?.map((etiket) => {
        return {
            content: (
                <a
                    href={user?.company?.companyConfig?.oldCrmPopleadsHttpLink + "/?campaignId=" + etiket?.campaignId}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <StyledCampaignLinkContent>{etiket.metin}</StyledCampaignLinkContent>
                </a>
            ),
        };
    });

    const totalCampaigns = etiketList?.length || 0;

    const handlePrevCampaign = (e) => {
        e.stopPropagation();
        if (currentCampaignIndex > 0) {
            setCurrentCampaignIndex(currentCampaignIndex - 1);
        }
    };

    const handleNextCampaign = (e) => {
        e.stopPropagation();
        if (currentCampaignIndex < totalCampaigns - 1) {
            setCurrentCampaignIndex(currentCampaignIndex + 1);
        }
    };

    const visibleCampaignItems =
        totalCampaigns > 0 && currentCampaignIndex < totalCampaigns ? [etiketList[currentCampaignIndex]] : [];

    const handleButtonClick = () => {
        if (showSearchCampaign) {
            setShowSearchCampaign(false);
        } else {
            if (popit) {
                toast.warning("You need to POP the profile first.");
            } else {
                setShowSearchCampaign(true);
                collapsedCards.course === true && setCollapsedCard("course", false);
            }
        }
    };

    return (
        <div ref={courseRef} style={{ padding: "12px 0px", borderBottom: "1px solid rgb(225, 225, 225)" }}>
            <Card
                isLoading={etiketListLoading}
                iconWidth="0px"
                homePage={true}
                collapsed={collapsed}
                onCollapseChange={handleCollapseChange}
                input={
                    <ExtensionCampaignSearchInput
                        label={false}
                        optionClick={(value) => {
                            etiketEkle({ profil: profile.id, etiket: value?.id });
                        }}
                    />
                }
                isShowInput={showSearchCampaign}
                button={
                    <HeaderButtonsWrapper>
                        {totalCampaigns > 1 && (
                            <>
                                <CarouselNavButton
                                    onClick={handlePrevCampaign}
                                    disabled={currentCampaignIndex === 0}
                                    aria-label="Previous campaign"
                                >
                                    <FeatherIcon icon="chevron-left" size={24} />
                                </CarouselNavButton>
                                <CarouselNavButton
                                    onClick={handleNextCampaign}
                                    disabled={currentCampaignIndex === totalCampaigns - 1}
                                    aria-label="Next campaign"
                                >
                                    <FeatherIcon icon="chevron-right" size={24} />
                                </CarouselNavButton>
                            </>
                        )}
                        <ButtonWithText
                            label={showSearchCampaign ? "Close campaign search" : "Add campaign"}
                            icon={showSearchCampaign ? "remove" : "add"}
                            iconType="material"
                            variant="l3rnTech"
                            buttonStyle="default"
                            size="circle"
                            onClick={handleButtonClick}
                        />
                    </HeaderButtonsWrapper>
                }
                cardTitle={profile?.etiket?.length > 0 ? `Campaigns (${profile?.etiket?.length})` : "Campaigns"}
                cardTitleOnClick={() => {
                    if (popit) {
                        toast.warning("You need to POP the profile first.");
                    } else {
                        setState({ popupContent: POPUP_CONTENTS.COURSES, popupIsOpen: true });
                    }
                }}
                cardItems={visibleCampaignItems}
                haveViewMore={false}
                minVisibleItems={0}
                errorDescription="Click the + to assign a campaign."
            />
        </div>
    );
};

export default ExtensionCourseCard;
